<template>
  <InstallPWADesktopView
    v-if="step === 0"
    :main-header="t$('.install.header')"
    :android-hint="t$('.install.android_hint')"
    :ios-hint="t$('.install.ios_hint')"
    :forwards-button-text="t$('.install.forwards_button')"
    @forwards="step = 1"
    @close="$emit('close')"
  >
    <template v-slot:android>
      <ScreenStepsRow
        :key="0"
        :step1="AndroidStep1"
        :step2="AndroidStep2"
        :step3="AndroidStep3"
      />
    </template>
    <template v-slot:ios>
      <ScreenStepsRow
        :key="1"
        :step1="IOSStep1"
        :step2="IOSStep2"
        :step3="IOSStep3"
      />
    </template>
  </InstallPWADesktopView>
  <InstallPWADesktopView
    v-else
    :main-header="t$('.activate.header')"
    :android-hint="t$('.activate.android_hint')"
    :ios-hint="t$('.activate.ios_hint')"
    :forwards-button-text="t$('.activate.forwards_button')"
    :backwards-button-text="t$('.activate.backwards_button')"
    @forwards="$emit('close')"
    @backwards="step = 0"
    @close="$emit('close')"
  >
    <template v-slot:android>
      <ScreenStepsRow
        :step1="AndroidStep4"
        :step2="AndroidStep5"
        :step3="AndroidStep6"
      />
    </template>
    <template v-slot:ios>
      <ScreenStepsRow :step1="IOSStep4" :step2="IOSStep5" :step3="IOSStep6" />
    </template>
  </InstallPWADesktopView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import InstallPWADesktopView from "features/push/InstallPWADesktopView.vue"
import ScreenStepsRow from "features/push/ScreenStepsRow.vue"

import AndroidStep1 from "./assets/install-screens/AndroidStep1.png"
import AndroidStep2 from "./assets/install-screens/AndroidStep2.png"
import AndroidStep3 from "./assets/install-screens/AndroidStep3.png"
import AndroidStep4 from "./assets/install-screens/AndroidStep4.png"
import AndroidStep5 from "./assets/install-screens/AndroidStep5.png"
import AndroidStep6 from "./assets/install-screens/AndroidStep6.png"

import IOSStep1 from "./assets/install-screens/IOSStep1.png"
import IOSStep2 from "./assets/install-screens/IOSStep2.png"
import IOSStep3 from "./assets/install-screens/IOSStep3.png"
import IOSStep4 from "./assets/install-screens/IOSStep4.png"
import IOSStep5 from "./assets/install-screens/IOSStep5.png"
import IOSStep6 from "./assets/install-screens/IOSStep6.png"
import useTranslate from "features/common/translate/concerns/useTranslate"

export default defineComponent({
  name: "InstallPWADesktopWizard",
  components: {
    ScreenStepsRow,
    InstallPWADesktopView,
  },
  props: {},
  computed: {
    AndroidStep1(): string {
      return AndroidStep1
    },
    AndroidStep2(): string {
      return AndroidStep2
    },
    AndroidStep3(): string {
      return AndroidStep3
    },
    AndroidStep4(): string {
      return AndroidStep4
    },
    AndroidStep5(): string {
      return AndroidStep5
    },
    AndroidStep6(): string {
      return AndroidStep6
    },
    IOSStep1(): string {
      return IOSStep1
    },
    IOSStep2(): string {
      return IOSStep2
    },
    IOSStep3(): string {
      return IOSStep3
    },
    IOSStep4(): string {
      return IOSStep4
    },
    IOSStep5(): string {
      return IOSStep5
    },
    IOSStep6(): string {
      return IOSStep6
    },
  },
  data() {
    return {
      step: 0,
    }
  },
  setup(props, context) {
    const preload = (src) => {
      const image = new Image()
      image.src = src
    }

    preload(AndroidStep1)
    preload(AndroidStep2)
    preload(AndroidStep3)
    preload(AndroidStep4)
    preload(AndroidStep5)
    preload(AndroidStep6)
    preload(IOSStep1)
    preload(IOSStep2)
    preload(IOSStep3)
    preload(IOSStep4)
    preload(IOSStep5)
    preload(IOSStep6)

    const { t$ } = useTranslate("components.push_wizard.install_pwa_wizard")

    return {
      t$,
    }
  },
})
</script>
